import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Bread from './pages/Bread';
import Cakes from './pages/Cakes';
import Brunsviger from './pages/Brunsviger';
import Bestilling from './pages/Bestilling';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/om-os" element={<About />} />
        <Route path="/broed" element={<Bread />} />
        <Route path="/kager" element={<Cakes />} />
        <Route path="/brunsviger" element={<Brunsviger />} />
        <Route path="/bestilling" element={<Bestilling />} />
        <Route path="/galleri" element={<Gallery />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/403" element={<Forbidden />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
